import { createSelector } from "reselect";
const _selectContract = (state) => state.contract;
export const selectContractsCollection = createSelector(
  [_selectContract],
  (contract) => contract.contractsList
);

export const selectIsContractsCollectionFetching = createSelector(
  [_selectContract],
  (contract) => contract.isFetching
);
export const selectIsSelectedContractDetailsFetching = createSelector(
  [_selectContract],
  (contract) => contract.isDetailsFetching
);
export const selectedContract = createSelector(
  [_selectContract],
  (contract) => contract.selectedContract
);
export const brand_details = createSelector(
  [_selectContract],
  (contract) => contract.brand_details
);
export const payment_terms = createSelector(
  [_selectContract],
  (contract) => contract.payment_terms
);
